const { BACKEND_HOST } = process.env;
const { BACKEND_PORT } = process.env;
export const { MOKA_SERVICE_HOST } = process.env;
export const { MOKA_OPEN_API_HOST } = process.env;
export const HOST = `${BACKEND_HOST}:${BACKEND_PORT}`;

export const API_URL = `${HOST}/api`;
export const REGISTER_URL = `${HOST}/validate_email?email=`;
export const VALIDATE_PHONE = `${HOST}/api/v1/validate_phone_number`;
export const GENERATE_OTP = `${MOKA_SERVICE_HOST}/account/v1/verification/phone/send`;
export const FORGOT_PASSWORD_VERIFY_OTP_URL = `${API_URL}/v2/users/verify_otp`;
export const FORGOT_PASSWORD_OTP_URL = `${API_URL}/v2/users/forgot_password`;
export const RESEND_VERIFICATION_EMAIL_URL = `${HOST}/resend_verification_email`;
export const BUSINESS_TYPES_URL = `${HOST}/business_types`;
export const BUSINESS_TYPES_URL_FROM_SERVICE = `${MOKA_SERVICE_HOST}/business-service/v1/business-types`;
export const BUSINESS_CATEGORIES_ALL_URL = `${HOST}/api/v1/business_categories_all`;
export const BUSINESS_CATEGORIES_ALL_URL_FROM_SERVICE = `${MOKA_SERVICE_HOST}/business-service/v1/business-categories`;
export const REGISTER_BUSINESS_URL = `${HOST}/api/v1/create_user`;
export const REFERRAL_URL = `${HOST}/referral`;
export const GET_RESET_PASSWORD_URL = `${API_URL}/v1/users/reset_password`;
export const RESET_PASSWORD_URL = `${API_URL}/v1/users/update_password`;
export const LOAD_PREPARE_ENCRYPTION_URL = `${API_URL}/v1/users/prepare_encryption`;
